// eslint-disable-next-line no-restricted-imports
import { defineMessages } from 'react-intl-next';

export const aiFailedStateMessages: {
	aupViolationMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	documentInsertError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tokenLimitExceeded: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rateLimitEnforced: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	apiError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	elevateDisabledGenerateError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	internalServerError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputTooShortError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hipaaContentError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	adfStreamingError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aifcAupViolationMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aifcApiError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aifcApiErrorRetry: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aifcTokenLimitExceeded: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aifcInputTooShortError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aifcHipaaContentError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aifcRateLimitEnforced: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aifcInternalServerError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aifcAdfStreamingError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noTextualContentError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	aupViolationMessage: {
		id: 'fabric.editor.ai.experience.aupViolationMessage',
		defaultMessage:
			'Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content.',
		description:
			'Message to indicate to user their prompt or content (this can be a range of content, such as a selection or document -- we used content to keep it vague -- as this will change without user knowing) has been detected as violating Atlassians acceptable use policy.  Note the markdown link -- this is expected to remain as markdown as this string is converted to html.',
	},

	documentInsertError: {
		id: 'fabric.editor.ai.experience-application.documentInsertError',
		defaultMessage: `We're having trouble inserting the response. Close the dialog and try again.`,
		description: 'Message to users that displays when error happens during document insertion.',
	},
	tokenLimitExceeded: {
		id: 'fabric.editor.ai.experience-application.tokenLimitExceeded',
		defaultMessage:
			"We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again.",
		description:
			'Message to users that displays when their request has exceeded the maximum input or output limit.',
	},
	rateLimitEnforced: {
		id: 'fabric.editor.ai.experience-application.rateLimitEnforced',
		defaultMessage:
			'We’ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>.',
		description: 'Message to users that rate limiting has been enforced.',
	},
	apiError: {
		id: 'fabric.editor.ai.experience.apiError',
		defaultMessage: `We couldn’t get a response, please try again.`,
		description: `We couldn't get a response due to an api error (ie. the backend responded with an error, or got a timeout)`,
	},

	elevateDisabledGenerateError: {
		id: 'fabric.editor.ai.experience.elevateDisabledGenetateError',
		defaultMessage: `Free generate is disabled in Elevate at this time.`,
		description: `Message to let internal users know that the free generate editor ai feature is is disabled in Elevate at this time.`,
	},
	internalServerError: {
		id: 'fabric.editor.ai.experience.internalServerError',
		defaultMessage: `Atlassian Intelligence (AI) isn’t responding. Try again later or <link>check the status of AI</link>.`,
		description: `We couldn't get a response due to an internal server error.`,
	},
	inputTooShortError: {
		id: 'fabric.editor.ai.experience.inputTooShortError',
		defaultMessage: `The content is too short to summarize. Please add more and try again.`,
		description: `The input was too short to summarize`,
	},
	hipaaContentError: {
		id: 'fabric.editor.ai.experience.hipaaContentError',
		defaultMessage: `Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again.`,
		description: `The input contained HIPAA content`,
	},
	adfStreamingError: {
		id: 'fabric.editor.ai.experience.adfStreamingError',
		defaultMessage: `Our apologies, we couldn't get a response.`,
		description: `This error message is displayed when error(s) are encountered during processing of LLM response in ADF format.`,
	},
	aifcAupViolationMessage: {
		id: 'fabric.editor.ai.experience.aifcAupViolationMessage',
		defaultMessage: 'Content does not comply with our <link>Acceptable Use Policy</link>.',
		description:
			'Error message to indicate to user their prompt or content (this can be a range of content, such as a selection or document -- we used content to keep it vague -- as this will change without user knowing) has been detected as violating Atlassians acceptable use policy.',
	},
	aifcApiError: {
		id: 'fabric.editor.ai.experience.aifcApiError',
		defaultMessage: 'An unknown error occurred.',
		description: 'Message for users when a non-retryable API error occurs.',
	},
	aifcApiErrorRetry: {
		id: 'fabric.editor.ai.experience.aifcApiErrorRetry',
		defaultMessage: 'An unknown error occurred. Please reload and try again.',
		description: 'Message for users when an API error occurs',
	},
	aifcTokenLimitExceeded: {
		id: 'fabric.editor.ai.experience.aifcTokenLimitExceeded',
		defaultMessage: 'There’s too much content to process. Select less content and try again.',
		description:
			'Message to users that displays when their request has exceeded the maximum input or output limit.',
	},
	aifcInputTooShortError: {
		id: 'fabric.editor.ai.experience.aifcInputTooShortError',
		defaultMessage:
			'More content needed to complete your request. Please select more content and try again.',
		description: 'Error message when the input was too short to process.',
	},
	aifcHipaaContentError: {
		id: 'fabric.editor.ai.experience.aifcHipaaContentError',
		defaultMessage:
			'Your content contains links to HIPAA restricted content. Remove links and try again.',
		description: 'Error message when HIPAA links have been detected.',
	},
	aifcRateLimitEnforced: {
		id: 'fabric.editor.ai.experience.aifcRateLimitEnforced',
		defaultMessage:
			'You’ve reached the <link>maximum number of requests</link>. Try again in 5 minutes.',
		description: 'Message to users that rate limiting has been enforced.',
	},
	aifcInternalServerError: {
		id: 'fabric.editor.ai.experience.aifcInternalServerError',
		defaultMessage:
			'Our apologies, we couldn’t get a response. Try again in 5 minutes or <link>check Rovo status</link>.',
		description: 'Error message when a Rovo internal server occurs.',
	},
	aifcAdfStreamingError: {
		id: 'fabric.editor.ai.experience.aifcAdfStreamingError',
		defaultMessage: 'Our apologies, we couldn’t get a response.',
		description:
			'This error message is displayed when error(s) are encountered during processing of LLM response in ADF format.',
	},
	noTextualContentError: {
		id: 'fabric.editor.ai.experience.noTextualContentError',
		defaultMessage:
			'More content needed to complete your request. Please select more content and try again.',
		description: 'Error message when the input has no textual content.',
	},
});
